/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect, use } from "react";
import { AuthContext } from "../util/api";
/* import axios from "axios"; */

import LawyerProfileSetup from "./newdesign";
import Navbar from "../header";
import { useNavigate } from "react-router-dom";
import Footer from "../footer";


//import { api, showAlert } from "../util/api";

const DoctorProfileForm = () => {

  const { User, token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (User == null || token == null) {
      navigate('/login');
    }
  }, []);

  return (

    <>
      < Navbar menuColor="black" />
      <section >
        <LawyerProfileSetup />

      </section>


      <Footer />





    </>
  );
};

export default DoctorProfileForm;
